import LoyaltyReferralTable, {
  LoyaltyReferralRow,
} from "../sponsorcommission/LoyaltyReferralTable";

const AusCommTable = ({ rows }: { rows: LoyaltyReferralRow[] }) => {
  return <LoyaltyReferralTable rows={rows} />;
};

export default AusCommTable;
